import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Box, Text } from "theme-ui";
import Scrollspy from "react-scrollspy";
import { Icon } from "../atoms";
import { colors, typography } from "../../styles/theme";

const StickyBottomMenu = ({ items, customStyles }) => {
	const itemLinks = items.map((i) => i.hash);

	return (
		<Box sx={{ ...styles.container, ...customStyles }}>
			<StyledScrollSpy
				items={itemLinks}
				currentClassName="is-current"
				style={{ ...typography.textMd500 }}
			>
				{items?.map(({ text, icon, hash, id }, i) => (
					<li key={`sticky-menu-item-${i}`}>
						<Link to={`#${hash}`} key={`item-${i}`} id={id}>
							<Icon name={icon} pointerCursor />
							<Text sx={{
                ...typography.textMd500,
              }}>
								{text}
							</Text>
						</Link>
					</li>
				))}
			</StyledScrollSpy>
		</Box>
	);
};

const styles = {
	container: {
		display: "block",
		p: "1.5rem 7.5rem",
		borderRadius: "99999px",
		width: "max-content",
		position: "fixed",
		bottom: "1.5rem",
		left: "50%",
		transform: "translate(-50%, 0)",
		mx: "auto",
		zIndex: 2000,
		background:
			"linear-gradient(0deg,rgba(255, 255, 255, 0.2) 0%,rgba(255, 255, 255, 0.2) 100%),rgba(237, 237, 237, 0.2)",
		backdropFilter: "blur(20px)",
		border: `1.14px solid ${colors.neutral200}`,
		"@media(max-width: 1203px)": {
			display: "none",
		},
	},
};

const StyledScrollSpy = styled(Scrollspy)`
	padding: 0;
	margin: 0;
	display: flex;
	gap: 3rem;
	& > li {
		list-style-type: none;
		padding: 0;
	}

	& > li > a {
		color: ${colors.black};
		text-decoration: none;
		transition: 1s all ease-in-out;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		svg {
			stroke: ${colors.black};
		}
	}

  & > li > a:hover {
    span {
			color: ${colors.primaryMain};
		}
		svg {
			stroke: ${colors.primaryMain};
		}
  }

	& > li.is-current > a {
		span {
			color: ${colors.primaryMain};
		}
		svg {
			stroke: ${colors.primaryMain};
		}
	}
`;

StickyBottomMenu.propTypes = {
	items: PropTypes.array.isRequired,
	customStyles: PropTypes.object,
};

export default StickyBottomMenu;
